/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu SIM (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Aug 16 2023
 **/

export const ModalID = {
	CONFIRM_CHANGE_SPACE_ADMIN: "CONFIRM_CHANGE_SPACE_ADMIN",
	CONFIRM_SPACE_DELETE: "CONFIRM_SPACE_DELETE",
	CONFIRM_SPACE_LEAVE: "CONFIRM_SPACE_LEAVE",
	DELETE_GROUP: "DELETE_GROUP",
	LEAVE_MEMBER: "LEAVE_MEMBER",
	GROUP_ALONE_MANAGER: "GROUP_ALONE_MANAGER",
	GROUP_ALONE_SPACE_MANAGER: "GROUP_ALONE_SPACE_MANAGER",
	INVITE_CHAT_MEMBER: "INVITE_CHAT_MEMBER",
	SHOW_CHAT_MEMBER: "SHOW_CHAT_MEMBER",
	SELECT_SPACE: "SELECT_SPACE",
	REMOVE_SPACE_MEMBER: "REMOVE_SPACE_MEMBER",
	DOMAIN_CHANGE: "DOMAIN_CHANGE",
	ADD_ACCOUNT: "ADD_ACCOUNT",
	CHANGE_SUCCESS: "CHANGE_SUCCESS",
	SIGN_IN: "SIGN_IN",
	SIGN_UP: "SIGN_UP",
	PROFILE_STATUS: "PROFILE_STATUS",
	SETTINGS: "SETTINGS",
	FILE_BOX: "FILE_BOX",
	DELETE_ACCOUNT_SUCCESS: "DELETE_ACCOUNT_SUCCESS",
	DELETE_ACCOUNT_FAIL: "DELETE_ACCOUNT_FAIL",
	RESET_PASSWORD: "RESET_PASSWORD",
	TERM_COLLECTION: "TERM_COLLECTION",
	TERM_MARKETING: "TERM_MARKETING",
	PARTICIPATION: "PARTICIPATION",
	SPACE_JOIN_REQUEST: "SPACE_JOIN_REQUEST",
	LOGOUT: "LOGOUT",
	INCLUDE_CONVERSATION: "INCLUDE_CONVERSATION",
	CREATE_SPACE_CHANNEL: "CREATE_SPACE_CHANNEL",
	OPEN_REMOTEVIEW_GVT: "OPEN_REMOTEVIEW_GVT",
	OPEN_VITA_GVT: "OPEN_VITA_GVT",
	MOVE_FILE: "MOVE_FILE",
	DOCUMENT_VIEWER: "DOCUMENT_VIEWER",
	DISCONNECTED_BY_OTHER_DEVICE: "DISCONNECTED_BY_OTHER_DEVICE",
	PROFILE_EDITOR: "PROFILE_EDITOR",
	SPACE_APPROVE_INVITED: "SPACE_APPROVE_INVITED",
	GAME_ROOM_SESSION_ERROR: "GAME_ROOM_SESSION_ERROR",
	REPEAT_SCHEDULE: "REPEAT_SCHEDULE",
	DELETE_MEETING: "DELETE_MEETING",
	SET_BACKGROUND_MYDESK: "SET_BACKGROUND_MYDESK",
	SET_WIDGET_MYDESK: "SET_WIDGET_MYDESK",
	CHAT_LINK_POPUP: "CHAT_LINK_POPUP",
	SPACE_THEME_UPDATED: "SPACE_THEME_UPDATED",
	ALERT_SPACE_THEME_UPDATE: "ALERT_SPACE_THEME_UPDATE",
	ALERT_CHAT_NOTIFICATION: "ALERT_CHAT_NOTIFICATION",
	CONFIRM_UPLOAD_FILE_TO_UNITY: "CONFIRM_UPLOAD_FILE_TO_UNITY",
	CANCEL_WRITING_CONFIRM: "CANCEL_WRITING_CONFIRM",
	STOP_CREATE_SPACE_CONFIRM: "STOP_CREATE_SPACE_CONFIRM",
	CONFIRM_FROM_UNITY: "CONFIRM_FROM_UNITY",
	CONFIRM_POPUP: "CONFIRM_POPUP",
	CALL_EXIST_POPUP: "CALL_EXIST_POPUP",
	CLOSE_POPUP_MY_ROOM: "CLOSE_POPUP_MY_ROOM",
	CONFIRM_DELETE_MEMBER_SPACE: "CONFIRM_DELETE_MEMBER_SPACE",
	CONFIRM_MINI_PROFILE_LOAD: "CONFIRM_MINI_PROFILE_LOAD",
	INVITE_TO_MEETING_POPUP: "INVITE_TO_MEETING_POPUP",
	CONFIRM_REQUEST_SUMMON_FRIEND: "CONFIRM_REQUEST_SUMMON_FRIEND",
	MYDESK_KNOCK_APPLY: "MYDESK_KNOCK_APPLY",
	USER_JOINED_SPACE_INFO: "USER_JOINED_SPACE_INFO",
	CAMERA_MIC_ALLOW_PERMISSION: "CAMERA_MIC_ALLOW_PERMISSION",
	ALLOW_PERMISSION: "ALLOW_PERMISSION",
	CHAT_VOTE: "CHAT_VOTE",
	DELETE_REPEAT_SCHEDULES: "DELETE_REPEAT_SCHEDULES",
	USER_NO_GROUP: "USER_NO_GROUP",
	INSTRUCT_CREATE_GROUP: "INSTRUCT_CREATE_GROUP",
	CREATE_GROUP_FOR_NEW_MEMBER: "CREATE_GROUP_FOR_NEW_MEMBER",
	USER_HAVE_INVITE: "USER_HAVE_INVITE",
	REQUIRED_FIELD: "REQUIRED_FIELD",
	ADMIN_USER_DELETE: "ADMIN_USER_DELETE",
	SET_AUTHORITY_ADMIN: "SET_AUTHORITY_ADMIN",
	DELETE_MEMBER_GROUP: "DELETE_MEMBER_GROUP",
	ADMIN_SPACE_MEMBER_LIST: "ADMIN_SPACE_MEMBER_LIST",
	ADMIN_SPACE_CHANNEL_LIST: "ADMIN_SPACE_CHANNEL_LIST",
	ADMIN_SPACE_CHANNEL_OF_USER_LIST: "ADMIN_SPACE_CHANNEL_OF_USER_LIST",
	REGISTER_BULK_USER: "REGISTER_BULK_USER",
	ERRORS_USER_UPLOADED: "ERRORS_USER_UPLOADED",
	ADD_USER_TO_GROUP: "ADD_USER_TO_GROUP",
	ORDER_SPACE_THEME: "ORDER_SPACE_THEME",
	CONFIRM_CONFERENCE_LEAVE: "CONFIRM_CONFERENCE_LEAVE",
	CREATE_FILEBOX_FOLDER: "CREATE_FILEBOX_FOLDER",
	ADMIN_USER_DELETE_CONFIRM: "ADMIN_USER_DELETE_CONFIRM",
	INVITE_ADMIN_PARTNER: "INVITE_ADMIN_PARTNER",
	DOCUMENT_VIEWER_PRESENTATION: "DOCUMENT_VIEWER_PRESENTATION",
	SPACE_SCREEN_SHARE: "SPACE_SCREEN_SHARE",
	ADD_USER_EXTENSION_NUMBER: "ADD_USER_EXTENSION_NUMBER"
} as const;

export type ModalID = (typeof ModalID)[keyof typeof ModalID];
